import React from 'react';
import { GuestSiteComponentProps } from '@apps/websiteCustomJsonComponents/types';
import { CustomThingToDoComponent, ThingToDoComponent, ThingToDoComponentProps } from '@apps/guest/packages/layout-engine/widgets/Custom/components/ThingToDo';
import { useThingsToDoExperimentV2 } from './useThingsToDoExperimentV2';
import { ThingsToDo } from './ThingsToDo.types';
import { ThingsToDoLoadingSkeleton } from '../shared/ThingsToDoLoadingSkeleton';
import { useLayout } from '@apps/guest/packages/layout-engine/layouts/LayoutProvider';
import { DesignLayoutType } from '@graphql/generated';
//import { useFindDefaultThingsToDoPageQuery } from '@graphql/generated';

// Tip:
// This is the component that is rendered on the guest site.
export const ThingsToDoGuest = (props: GuestSiteComponentProps) => {
  const { componentLayout, loading } = useThingsToDoExperimentV2();
  const { layout } = useLayout();
  const isAlohaLayout = layout === DesignLayoutType.aloha;
  const designType = isAlohaLayout ? 'widget' : 'fullRow';

  // Show skeleton while loading
  if (loading) {
    return <ThingsToDoLoadingSkeleton />;
  }

  const thingsToDoContent: ThingsToDo = props.jsonComponentData.containerContent.content;
  const data: ThingToDoComponentProps = {
    id: thingsToDoContent.poi.id,
    title: thingsToDoContent.poi.title,
    category: thingsToDoContent.poi.category,
    description: thingsToDoContent.poi.description ?? '',
    image: thingsToDoContent.poi.image,
    url: thingsToDoContent.poi.url,
    sortOrder: 0,
    tours: thingsToDoContent.poi.tours,
    location: thingsToDoContent.location.city || undefined,
  };

  if (componentLayout) {
    return (
      <ThingToDoComponent
        {...data}
        layoutType={componentLayout}
        designType="widget"
        forceFullWidth={isAlohaLayout}
      />
    );
  }

  return data.tours && data.tours.length > 0 ? (
    <ThingToDoComponent
      {...data}
      layoutType={'sidebar'}
      forceFullWidth={isAlohaLayout}
    />
  ) : (
    <CustomThingToDoComponent
      {...data}
      designType={designType}
      forceFullWidth={isAlohaLayout}
    />
  );
};
